import { memo } from 'react'
import { Text } from 'common-components'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'
import QualityDropdown from './QualityDropdown'
import { useAvatarQuality } from './useAvatarQuality'
import * as Styled from './styled'

const QualitySection: React.FC = () => {
  const { quality, options, onSelect } = useAvatarQuality()

  return (
    <Styled.QualitySectionContainer>
      <Text type="subtitle" color="secondaryDark">
        {translate(T.QUALITY_LABEL)}
      </Text>

      <QualityDropdown
        options={options}
        selectedValue={quality}
        onSelect={onSelect}
      />
    </Styled.QualitySectionContainer>
  )
}

export default memo(QualitySection)
